/* This validates customer inputs; illustration and proof approval remain manual. */
function validateDogPortraitInput({ file, imageReady, consent, name = '', notes = '', ordersEnabled }) {
  if (!ordersEnabled) return 'Custom portrait ordering is not open yet.';
  if (!file) return 'Choose a photo of your pet.';
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return 'Choose a JPG, PNG or WebP photo.';
  if (!file.size || file.size > 10 * 1024 * 1024) return 'Choose a photo smaller than 10 MB.';
  if (!imageReady) return 'Wait for a valid photo preview before adding your item.';
  if (name.length > 40 || notes.length > 300) return 'Keep the name under 40 characters and notes under 300 characters.';
  if (!consent) return 'Confirm photo permission and the design approval step.';
  return '';
}
if (typeof module !== 'undefined') module.exports = { validateDogPortraitInput };

if (typeof customElements !== 'undefined' && !customElements.get('dog-portrait-fields')) {
  customElements.define('dog-portrait-fields', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.fileInput = this.querySelector('[data-dog-photo]');
      this.image = this.querySelector('[data-dog-preview]');
      this.preview = this.querySelector('figure');
      this.error = this.querySelector('[data-dog-error]');
      this.onPhotoChange = () => this.previewPhoto();
      this.fileInput.addEventListener('change', this.onPhotoChange);
      // A draft service must stay blocked even if variant selection toggles Dawn's button.
      this.form = this.closest('form');
      this.blockDraft = (event) => {
        if (this.dataset.ordersEnabled !== 'true') {
          event.preventDefault(); event.stopImmediatePropagation(); this.showError('Custom portrait ordering is not open yet.');
        }
      };
      this.form?.addEventListener('submit', this.blockDraft, true);
      this.previewPhoto();
    }
    disconnectedCallback() {
      this.fileInput?.removeEventListener('change', this.onPhotoChange);
      this.form?.removeEventListener('submit', this.blockDraft, true);
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.initialized = false;
    }
    previewPhoto() {
      this.imageReady = false;
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
      this.preview.hidden = true;
      this.image.removeAttribute('src');
      this.error.hidden = true;
      const file = this.fileInput.files?.[0];
      if (!file) return;
      const problem = validateDogPortraitInput({ file, ordersEnabled: true, imageReady: true, consent: true });
      if (problem) { this.showError(problem); return; }
      const url = URL.createObjectURL(file);
      this.objectUrl = url;
      this.image.onload = () => {
        if (this.objectUrl !== url) return;
        this.imageReady = true; this.preview.hidden = false;
        this.querySelector('[data-dog-file-name]').textContent = file.name;
      };
      this.image.onerror = () => {
        if (this.objectUrl !== url) return;
        this.imageReady = false; this.preview.hidden = true;
        this.showError('This photo could not be opened. Try a different JPG, PNG or WebP.');
      };
      this.image.src = url;
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    validate() {
      const message = validateDogPortraitInput({
        file: this.fileInput.files?.[0], imageReady: this.imageReady,
        consent: this.querySelector('[data-dog-consent]').checked,
        name: this.querySelector('[data-dog-name]').value,
        notes: this.querySelector('[data-dog-notes]').value,
        ordersEnabled: this.dataset.ordersEnabled === 'true'
      });
      if (message) { this.showError(message); this.error.focus(); return false; }
      this.error.hidden = true; return true;
    }
  });
}
